import * as React from "react";
import PropTypes from "prop-types";
import { makeResetStyles, Option, Dropdown } from "@fluentui/react-components";
import { FluentField } from "../../../../components/FluentUI/Fluent-Field";
import './sub-department.scss';

const useStackClassName = makeResetStyles({
  display: "flex",
  flexDirection: "column",
  rowGap: '12px',
  textAlign: "left",
});

export const UserDefaults = ({ subDepartment, setSubDepartment, errors, setErrors }) => {

  const handleProjectTemplateSelect = (_, data) => {
    const selectedOption = subDepartment?.allProjectTemplates?.find(option => option.Id === data.optionValue);
    setSubDepartment({
      ...subDepartment,
      DefaultProjectTemplate: selectedOption,
    });
  };

  const handleTaskTypeSelect = (_, data) => {
    const selectedOption = subDepartment.allTaskTypes.find(option => option.Id === data.optionValue);
    setSubDepartment({
      ...subDepartment,
      DefaultTaskType: selectedOption,
    });
  };

  const handleStartPageSelect = (_, data) => {
    setSubDepartment({
      ...subDepartment,
      DefaultStartPage: data.optionValue,
    });
  };

  const startPageOptions = ["Tasks", "Projects", "Dashboard", "Admin"];

  return (
    <div className={`${useStackClassName()} sub-department-general`}>

      <FluentField label="Default Project Template">
        <Dropdown
          placeholder="Select Project Template"
          value={subDepartment?.DefaultProjectTemplate?.ProjectType || ""}
          selectedOptions={[subDepartment?.DefaultProjectTemplate?.Id || ""]}
          onOptionSelect={handleProjectTemplateSelect}
        >
          {subDepartment?.allProjectTemplates?.map((option) => (
            <Option key={option.Id} value={option.Id}>
              {option.ProjectType}
            </Option>
          ))}
        </Dropdown>
      </FluentField>

      <FluentField label="Default Task Type" >
        <Dropdown
          placeholder="Select Task Type"
          value={subDepartment?.DefaultTaskType?.Type || ""}
          selectedOptions={[subDepartment?.DefaultTaskType?.Id || ""]}
          onOptionSelect={handleTaskTypeSelect}
        >
          {subDepartment.allTaskTypes.map((option) => (
            <Option key={option.Id} value={option.Id}>
              {option.Type}
            </Option>
          ))}
        </Dropdown>
      </FluentField>

      <FluentField label="Default Start Page" >
        <Dropdown
          value={subDepartment?.DefaultStartPage || "Tasks"}
          selectedOptions={[subDepartment?.DefaultStartPage || "Tasks"]}
          onOptionSelect={handleStartPageSelect}
        >
          {startPageOptions.map((option) => (
            <Option key={option} value={option}>
              {option}
            </Option>
          ))}
        </Dropdown>
      </FluentField>
    </div>
  );
};

UserDefaults.propTypes = {
  subDepartment: PropTypes.shape({
    Name: PropTypes.string,
    Departments: PropTypes.array,
    allDepartments: PropTypes.array,
    allTaskTypes: PropTypes.array,
    allProjectTemplates: PropTypes.array,
    DefaultProjectTemplate: PropTypes.shape({
      Id: PropTypes.number,
      ProjectType: PropTypes.string,
    }),
    DefaultTaskType: PropTypes.shape({
      Id: PropTypes.number,
      Type: PropTypes.string,
    }),
    Active: PropTypes.bool,
  }).isRequired,
  setSubDepartment: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired, 
  setErrors: PropTypes.func.isRequired,
};
